module.exports = "<p>\n  role-list works!\n</p>\n"